import styled from "styled-components";

export const SectionContainer = styled.section`
  background-color: #cff5d0;
  text-align: center;
  padding: 60px 20px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SectionContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-size: 32px;
  color: #2f8147;
  margin-bottom: 24px;
  text-transform: uppercase;
  font-weight: 700;
`;

export const Description = styled.p`
  font-size: 18px;
  color: #333;
  line-height: 1.5;
`;
